<template>
    <span>{{ formattedDate }}</span>
</template>

<script lang="ts">
const locale = navigator.language;

export default {
    props: ['params'],
    computed: {
        formattedDate() {
            const dateValue = this.params.value;
            if (dateValue) {

                return Intl.DateTimeFormat(locale, {
                    day: 'numeric',
                    month: 'short',
                    year: 'numeric',
                    // hour: '2-digit',
                    // minute: '2-digit',
                    timeZone: 'UTC'
                }).format(new Date(dateValue));
            }
            return '';
        }
    }
};
</script>

<style scoped lang="scss">

</style>